import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectStartHours = createFeatureSelector<any>('start-hours');

export const selectStartHoursState = createSelector(
    selectStartHours,
    (state: any) => state,
);
